import {
  ActionType,
  IUpdateReleaseDatePayload,
  UpdateReleaseDateResponse,
} from "models/userListBusiness/updateReleaseDate";

export const updateReleaseDateAction = (payload: IUpdateReleaseDatePayload) => {
  return {
    type: ActionType.UPDATE_RELEASE_DATE,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_RELEASE_DATE_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: UpdateReleaseDateResponse) => {
  return {
    type: ActionType.UPDATE_RELEASE_DATE_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.UPDATE_RELEASE_DATE_RESET,
  };
};
